import noop from "lodash/noop";
import { createContext, useContext } from "react";

import { ModalContextType, ModalContextValue } from "./modal_context.types";

const INITIAL_MODAL_CONTEXT: ModalContextType = {
  closeWithAnimation: noop,
  portalRef: undefined
};

export const ModalContext = createContext<ModalContextType>(null);

export const useModalContext = (): ModalContextValue => {
  const modalContext = useContext<ModalContextType>(ModalContext);

  return modalContext || INITIAL_MODAL_CONTEXT;
};
